export default "__VITE_ASSET__NQdu0kTP__"